/* tslint:disable */
export const DemoTask = {
  header: {
    title: 'Application Form',
  },
  description: {
    title: '',
  },
  print: {},
  handlers: {
    onloadscript:
      "if(frm.getValue('ApplicantIDNP') == ''){\nfrm.setValue('ApplicantType', '1');\n\nfrm.setValue('ApplicantIDNP', '01234566789');\nfrm.setValue('BeneficiaryIDNO', '01234566789');\nfrm.setValue('ApplicantFirstName', 'Leonid');\nfrm.setValue('ApplicantLastName', 'Popusoi');\nfrm.setValue('ApplicantPosition', 'Dev');\n}",
  },
  hiddenCells: [
    {
      colSpan: 0,
      properties: {
        onCreateValue: '~USERID',
      },
      name: 'CreatedBy',
      rowSpan: 0,
      showHelp: false,
      title: 'Created By',
    },
    {
      colSpan: 0,
      properties: {
        onCreateValue: '~NOW',
      },
      name: 'CreatedOn',
      rowSpan: 0,
      showHelp: false,
      title: 'CreatedOn',
    },
    {
      colSpan: 0,
      properties: {
        onCreateValue: '~NOW',
        onUpdateValue: '~NOW',
      },
      name: 'ModifiedOn',
      rowSpan: 0,
      showHelp: false,
      title: 'Modified On',
    },
    {
      colSpan: 0,
      properties: {
        onCreateValue: '~IP',
        onUpdateValue: '~IP',
      },
      name: 'ModifiedIP',
      rowSpan: 0,
      showHelp: false,
      title: 'Modified IP',
    },
    {
      colSpan: 0,
      properties: {
        onCreateValue: '~USERID',
        onUpdateValue: '~USERID',
      },
      name: 'ModifiedBy',
      rowSpan: 0,
      showHelp: false,
      title: 'Modified By',
    },
    {
      colSpan: 0,
      properties: {
        onCreateValue: '~APPLICATIONID',
      },
      name: 'ApplicationId',
      rowSpan: 0,
      showHelp: false,
      title: 'Application Id',
    },
    {
      colSpan: 0,
      properties: {
        onCreateValue: '~IP',
      },
      name: 'CreatedIP',
      rowSpan: 0,
      showHelp: false,
      title: 'Created IP',
    },
  ],
  tabs: [
    {
      name: 'tab_general',
      sections: [
        {
          columns: 2,
          decoration: 'line',
          name: 'sec_info',
          rows: [
            {
              cells: [
                {
                  colSpan: 0,
                  properties: {
                    requiredLevel: 'required',
                  },
                  name: 'ApplicationDate',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Application Date',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 2,
                  properties: {
                    readOnly: 'control',
                    requiredLevel: 'recommended',
                  },
                  name: 'PermitTypeId',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Permit Type',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 2,
                  properties: {
                    readOnly: 'true',
                    requiredLevel: 'recommended',
                  },
                  name: 'AuthorityId',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Authority',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 0,
                  properties: {
                    requiredLevel: 'required',
                  },
                  name: 'PermitProcessingTeamId',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Service Location',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 0,
                  properties: {
                    requiredLevel: 'required',
                  },
                  name: 'ApplicantType',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Applicant Type',
                },
                {
                  colSpan: 0,
                  name: 'BeneficiaryIDNO',
                  rowSpan: 0,
                  showHelp: false,
                  title: "Applicant's IDNO / IDNP",
                },
              ],
            },
          ],
          showlabel: true,
          title: 'Info',
        },
        {
          columns: 3,
          decoration: 'line',
          name: 'sec1562',
          rows: [
            {
              cells: [
                {
                  colSpan: 0,
                  name: 'ApplicantIDNP',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'IDNP',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantFirstName',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'First name',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantPosition',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Position of Applicant',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 0,
                  name: 'ApplicantBirthDate',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Birth date',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantLastName',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Last Name',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 2,
                  name: 'ApplicantEmail',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Email',
                },
                {
                  colSpan: 1,
                  name: 'ApplicantPhone',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Phone',
                },
              ],
            },
          ],
          showlabel: true,
          title: 'Applicant data',
        },
        {
          columns: 3,
          decoration: 'line',
          name: 'sec1414',
          rows: [
            {
              cells: [
                {
                  colSpan: 0,
                  name: 'ApplicantAddressDistrict',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'District / Municipality',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantAddressCity',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'City / commune',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantAddressSector',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Sector / village',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 2,
                  name: 'ApplicantAddressStreet',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Street',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantAddressHouse',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'House',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 0,
                  name: 'ApplicantAddressPostalCode',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Postal code',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantAddressBlock',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Block',
                },
                {
                  colSpan: 0,
                  name: 'ApplicantAddressApartment',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Apartment',
                },
              ],
            },
            {
              cells: [
                {
                  colSpan: 0,
                  name: 'ApplicantPhone',
                  rowSpan: 0,
                  showHelp: false,
                  title: 'Phone',
                },
              ],
            },
          ],
          showlabel: true,
          title: 'Applicant address',
        },
      ],
      title: 'General',
    },
  ],
  uiActions: [],
};
